import React, { useEffect, useState } from "react";
import DashboardRoutes from "routes/DashboardRoutes";
import { Grid, Segment } from "semantic-ui-react";
import CollectiveMenu from "components/features/CollectiveMenu";
import { useDispatch, useSelector } from "react-redux";

import { categoryActions } from "reducers/categoryReducer";
import { productActions } from "reducers/productReducer";
import { supplierActions } from "reducers/supplierReducer";
import http from "utilities/http";
import Alerts from "utilities/Alerts";
import { notificationActions } from "reducers/notificationReducer";

function Dashboard() {
	const dispatch = useDispatch();
	const { token } = useSelector((state) => state.user);
	const [loadingData, setLoadingData] = useState(false);
	// populate store
	useEffect(() => {
		if (token) {
			const getProducts = http.get("/products");
			const getCategories = http.get("/categories");
			const getSuppliers = http.get("/suppliers");
			const getNotifications = http.get("/notifications");

			setLoadingData(true);

			Promise.all([
				getProducts,
				getCategories,
				getSuppliers,
				getNotifications,
			])
				.then((responses) => {
					const [
						{ data: productData },
						{ data: categoryData },
						{ data: supplierData },
						{ data: notifications },
					] = responses;
					dispatch(
						productActions.populateProducts(productData.products)
					);
					dispatch(
						categoryActions.populateCategories(
							categoryData.categories
						)
					);
					dispatch(
						supplierActions.populateSuppliers(
							supplierData.suppliers
						)
					);
					dispatch(
						notificationActions.populateUnread(notifications.unread)
					);
				})
				.catch(() =>
					Alerts.error("Reload.", "Could not fetch data from server.")
				)
				.finally(() => setLoadingData(false));
		}
	}, [dispatch, token]);
	return (
		<>
			<Grid style={{ height: "100vh" }}>
				<Grid.Column width={3}>
					<CollectiveMenu />
				</Grid.Column>
				<Grid.Column width={13}>
					<Segment loading={loadingData} basic padded="very">
						<DashboardRoutes />
					</Segment>
				</Grid.Column>
			</Grid>
		</>
	);
}

export default Dashboard;
